<template>
  <settings-panel>
    <template #title>
      Password
    </template>

    <div class="sm:max-w-md w-full">
      <form @submit.prevent="savePassword" method="post" class="space-y-6">
        <div>
          <label for="current_password" class="block text-yank font-medium text-sm">
            Current Password
          </label>
          <div class="mt-1 shadow-sm rounded-xl">
            <input type="password" name="current_password" id="current_password" v-model="form.current_password" class="form-input" required>
          </div>
          <div v-if="errors.current_password" class="text-sm text-red-600 mt-1">
            {{ errors.current_password }}
          </div>
        </div>

        <div>
          <label for="password" class="block text-yank font-medium text-sm">
            New Password
          </label>
          <div class="mt-1 shadow-sm rounded-xl">
            <input type="password" name="password" id="password" v-model="form.password" class="form-input" required>
          </div>
          <div v-if="errors.password" class="text-sm text-red-600 mt-1">
            {{ errors.password }}
          </div>
        </div>

        <div>
          <label for="password_confirmation" class="block text-yank font-medium text-sm">
            Confirm New Password
          </label>
          <div class="mt-1 shadow-sm rounded-xl">
            <input type="password" name="password_confirmation" id="password_confirmation" v-model="form.password_confirmation" class="form-input" required>
          </div>
          <div v-if="errors.password_confirmation" class="text-sm text-red-600 mt-1">
            {{ errors.password_confirmation }}
          </div>
        </div>

        <div>
          <button type="submit" class="h-11 px-6 text-sm text-white font-semibold rounded-xl bg-aquamarine hover:opacity-90 transition focus:outline-none focus:ring-2 focus:ring-aquamarine focus:ring-offset-2 disabled:opacity-60 flex items-center justify-center disabled:bg-payneFire" :disabled="working">
            <LoadingIcon v-if="working" class="text-white h-5 w-5 -ml-1 mr-2" />
            <span>Update Password</span>
          </button>
        </div>
      </form>
    </div>
  </settings-panel>
</template>

<script>
  import SettingsPanel from '@/components/settings/partials/SettingsPanel'
  import LoadingIcon from '@/components/svg/LoadingIcon'

  export default {
    name: 'PasswordSettings',

    components: {
      SettingsPanel,
      LoadingIcon,
    },

    data() {
      return {
        working: false,
        form: {
          current_password: '',
          password: '',
          password_confirmation: '',
        }
      }
    },

    computed: {
      errors() {
        return this.$page.props.errors
      }
    },

    methods: {
      savePassword() {
        this.working = true

        this.$inertia.put(this.$route('profile-settings.updatePassword'), this.form, {
          onFinish: () => {
            this.working = false
            this.resetForm()
          }
        })
      },

      resetForm() {
        this.form.current_password = ''
        this.form.password = ''
        this.form.password_confirmation = ''
      }
    }
  }
</script>
